import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import { v4 as uuidv4 } from "uuid";
/*import { ProgressBar } from 'react-bootstrap';
import streamSaver from 'streamsaver';*/
//import axios from "axios";

import lockGrey from '../assets/img/lockGrey.png';

import '../assets/css/bootstrap.min.css';
import '../assets/css/app.css';
import '../assets/css/fonts.css';

import Footer from './Footer';
import RightSide from './RightSide';
import FileNotFound from './FileNotFound';
import WrongToken from './WrongToken';

import { checkFileType } from '../utils/utils';
import SuccessDownload from './SuccessDownload';

let BASE_URL;

if (/localhost/.test(window.location.host)) {
    BASE_URL = 'https://api.staging.lockself.com';
}
else {
    BASE_URL = window.location.origin;
}


class EmailProtectFragment extends Component {
    constructor(props) {
        super(props)

        this.state = {
            content: null,
            isComplete: false,
            isDownloading: false,
            passKey: "",
            progress: 0,
            downloadStatus: null,
            /*states for download files in V2 */
            transferIsBigFile: "",
            transferLinkForBigFile: "",
            transferContent: null
        }
    }

    progressDownload = (e) => {
        let percentCompleted = Math.round((e.loaded * 100) / e.total);
        this.setState({ progress: percentCompleted });
        if (this.state.progress === 100) {
            this.setState({
                isComplete: true
            })
        }
    }

    downloadFileV2 = async (e, fileName) => {
        let that = this

        const isIE = /*@cc_on!@*/false || !!document.documentMode;

        function handleError(xhr) {
            console.log("Error", xhr)
            that.setState({
                isDownloading: false,
                isCompleted: false,
                downloadStatus: false
            })
        }

        function handleComplete() {
            that.setState({
                isComplete: true,
                downloadStatus: true
            })
        }

        let data = JSON.stringify({
            hash1: this.props.transferHash1,
            hash2: this.props.transferHash2,
            uh1: this.props.userHash1,
            uh2: this.props.userHash2,
            token: this.state.passKey,
            download: true
        })

        var xhr = new XMLHttpRequest();

        xhr.open("POST", `${BASE_URL}/api/external/transfers/email/download`)
        xhr.setRequestHeader("Content-Type", "application/json")
        xhr.responseType = "blob"
        xhr.send(data)

        xhr.onreadystatechange = function (oEvent) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {

                    var blob = this.response; //new Blob([data], {type: "application/json"})

                    if (isIE) {
                        navigator.msSaveOrOpenBlob(blob, fileName)
                    } else {
                        var a = document.createElement('a')
                        a.href = URL.createObjectURL(blob)
                        a.download = fileName;   //<--- ici ça permet de donner un nom au ficher
                        document.body.appendChild(a)
                        a.click()
                    }

                    handleComplete()

                } else {
                    handleError(xhr)
                }
            }
        }
    }

    downloadFile = async (e, fileName) => {
        let that = this // Je sais pas si c'est très propre de faire ça mais bon j'ai pas trouvé mieux là dans l'urgence :)


        function handleError(xhr) {
            console.log("Error", xhr)
            that.setState({
                isDownloading: false,
                isCompleted: false,
                downloadStatus: false
            })
        }

        function handleComplete() {
            that.setState({
                isComplete: true,
                downloadStatus: true
            })
        }

        async function downloadFiles(url, fileName) {
            let link = document.createElement("a")
            link.id = "downloadLink"
            link.setAttribute("href", url)
            link.setAttribute("download", fileName)
            document.body.appendChild(link)

            link.click()
            link.remove()
        }

        const sessionToken = uuidv4()
        let headers = {
            "Content-Type": "application/json",
            'X-Download-Session': sessionToken
        }

        async function finalDownload(link, fileName) {
            await downloadFiles(link, fileName)
        }

        const transferList = [
            ...this.props.transferLinked,
            {
                name: this.props.name,
                id: this.props.id,
                size: this.props.size
            }
        ];

        for (const file of transferList) {
            try {
                const requestOptions = {
                    method: "POST",
                    headers: headers,
                    body: JSON.stringify({
                        method: "downloadSingleTransferEmail",
                        transferHash1: this.props.transferHash1,
                        transferHash2: this.props.transferHash2,
                        transferUh1: this.props.userHash1,
                        transferUh2: this.props.userHash2,
                        token: this.state.passKey,
                        fileIds: file.id.toString(),
                    })
                }
                const res = await fetch(`${BASE_URL}/api/download/generate/token`, requestOptions)
                const data = await res.json()

                await finalDownload(data.link, file.name)

                // Petite pause pour laisser le navigateur respirer
                await new Promise((resolve) => setTimeout(resolve, 500))

            } catch (err) {
                handleError("Fichier corrompu", file.name, err)
            }

        }
        handleComplete()
    }



    updateTokenValue = (e) => {
        this.setState({ passKey: e.target.value });
    }

    handleKeyPressed = (e, fileName) => {
        if (e.key === 'Enter') {
            this.downloadFile(e, fileName)
        }
    }

    clickDownloadButton(e, status) {
        document.getElementById("orangeBtn").setAttribute("disabled", "disabled");
        this.setState({
            isDownloading: true,
            progress: 100
        });
        /*let loaderWrapper = document.getElementsByClassName("loader-wrapper");
        loaderWrapper[0].style.display = "block";
        loaderWrapper[0].style.opacity = 1;*/
        document.getElementById("inputToken").setAttribute("type", "hidden");
        if (this.props.token.length === 5) {
            this.downloadFileV2(e, this.props.name);
        } else if (this.props.token.length === 6) {
            this.downloadFile(e, this.props.name);
            if (200 === status) {
                setTimeout(() => {
                    /*let loaderWrapper = document.getElementsByClassName("loader-wrapper");
                    loaderWrapper[0].style.display = "none";
                    loaderWrapper[0].style.opacity = 0;*/
                    this.setState({ isComplete: true, isDownloading: false });
                }, 5000);
            }
        }

    }

    displayInputToken(isComplete, passKey, t) {
        if (!isComplete) {
            return (
                <input id="inputToken" type="text" placeholder={t("email.token")} value={passKey} lockself="lockself" onChange={e => this.updateTokenValue(e)} onKeyDown={e => this.handleKeyPressed(e, this.props.name)} />
            )
        }
    }

    displayDownloadInfo(isComplete, isDownloading, status, t) {

        /*if (isComplete) {
            return (
                <img className="completeDownload" src={tick} alt="complete Download" />
            );
        }*/

        if (!isComplete && !isDownloading) {
            return (
                <button id="orangeBtn" className="orangeBtn" onClick={e => this.clickDownloadButton(e, status)}>{t("general.download")}</button>
            );
        }

        if (isDownloading) {
            return (
                <div></div>
            )
        }
    }

    displayCard = (isComplete, linked, name, size, passKey, isDownloading, status, t) => {
        if (isComplete) {
            return (
                <SuccessDownload />
            )
        }
        else {
            return (
                <div className="Card tokenVs">

                    {linked?.length ?
                        <div className="mfMapFrame">
                            <b className="title">
                                {linked.length+1} {t("general.files")}
                            </b>

                            <div className="mfMap">
                                <div>
                                    <div>
                                        <i className={checkFileType(name)}></i>
                                        <b>{name}</b>
                                    </div>
                                    <span>{size}</span>
                                </div>

                                {linked.map((f,fi) => (
                                    <div key={fi}>
                                        <div>
                                            <i className={checkFileType(f.name)}></i>
                                            <b>{f.name}</b>
                                        </div>
                                        <span>{f.size}</span>
                                    </div>
                                ))}
                            </div>

                        </div>
                        :
                        <>
                            <div className="file-type">
                                <i className={checkFileType(name)}></i>
                            </div>
                            <div>
                                <span>
                                    <h2>{name}</h2>
                                    <div className="transferSize">
                                        <span className="grey_pill">{size}</span>
                                    </div>
                                </span>
                            </div>
                        </>
                    }

                    {this.displayInputToken(isComplete, passKey, t)}
                    {this.displayDownloadInfo(isComplete, isDownloading, status, t)}
                    {this.displayDownloadLoader(isDownloading)}
                </div>
            )
        }
    }

    displayDownloadLoader = (isDownloading) => {
        if (isDownloading) {
            return (
                <div className="loader-wrapper" id="loader-wrapper">
                    <img src={lockGrey} alt="Cadenas : chargement" />
                    <div id="loader" />
                    <div className="loader-section-transparent section-left" />
                    <div className="loader-section-transparent section-right" />
                </div>
            )
        }
    }

    render() {
        const { t } = this.props;
        const { token, linked, name, size, userEmail, userFname, userLname, whitemarkBackground, whitemarkBtnColor, whitemarkFavicon, whitemarkLogo, whitemarkTitle } = this.props;
        const { downloadStatus, isComplete, isDownloading, passKey } = this.state
        const positionContainer = this.state.displayAbout ? ["slideToLeft"] : ["col-xl-4 col-lg-5 col-md-6 col-sm-8 col-xs-12 mColumn"]

        if (downloadStatus === false) {
            return <WrongToken whitemarkTitle={whitemarkTitle} whitemarkFavicon={whitemarkFavicon} whitemarkBackground={whitemarkBackground} whitemarkLogo={whitemarkLogo} />
        }

        if (this.props.status === 404) {
            return <FileNotFound whitemarkTitle={whitemarkTitle} whitemarkFavicon={whitemarkFavicon} whitemarkBackground={whitemarkBackground} whitemarkLogo={whitemarkLogo} />
        }

        return (
            <div className="main">
                <Helmet>
                    <title>{whitemarkTitle}</title>
                    {<link rel="shortcut icon" href={whitemarkFavicon} />}
                    <style type="text/css">
                        {`
                                .main {
                                    background:url(${whitemarkBackground});
                                    background-size:cover;
                                }

                                .main>div.darker{
                                    background-color: rgba(32,32,48,0.7);
                                    min-height: 100vh;
                                }

                                button.orangeBtn {
                                    background-color: ${whitemarkBtnColor};
                                }

                                .logoPrincipal {
                                    background-image: url(${whitemarkLogo});
                                }
                            `}
                    </style>
                </Helmet>
                <div className="noDark">
                    <div className="container">
                        <div className="row">
                            <div className={positionContainer}>
                                <div className="logoPrincipal">&nbsp;</div>
                                <div className="">
                                    <div>
                                        <h3 className="senderLabel">{t("general.sender")}</h3>
                                        <div className="Card sender">
                                            <span>{userFname.charAt(0) + userLname.charAt(0)}</span>
                                            <span>
                                                <h1>{userFname + " " + userLname}</h1>
                                                <h3>{userEmail}</h3>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="shareLabel">
                                        <h2>{t("general.title")}</h2>
                                    </div>
                                    <div className="Central">
                                        {this.displayCard(isComplete, linked, name, size, passKey, isDownloading, downloadStatus, t)}
                                        <div className="shareId">
                                            <span>#{token}</span>
                                        </div>
                                    </div>
                                </div>
                                <Footer />
                            </div>
                        </div>
                        <RightSide transferIsAvailable={true} />
                    </div>
                </div>
            </div>
        )

    }
}

export default withTranslation()(EmailProtectFragment)
